<template>
    <div id="doughnut-metric" class="tile" :class="[{ 'is-parent': isParent }, metricSize]">
        <article class="tile is-child notification is-white metric metric-primary metric-fixed">
            <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="false"></b-loading>
            <div class="columns is-mobile" v-if="!loading">
                <div class="column" :class="{ 'is-7': chartDataTotal }">
                    <p class="title">{{ theTitle }}</p>
                </div>
                <div class="column has-text-right" v-if="chartDataTotal">
                        <div class="metric-total">
                            ( {{ chartDataTotal }} total )
                        </div>
                </div>
            </div>
            <b-notification v-if="!loading && !hasChartData" :closable="false">{{ noDataMessage }}</b-notification>
            <div class="columns is-mobile" v-if="!loading && hasChartData">
                <div class="column is-8 is-12-mobile">
                    <ul :class="{'is-full' : chartKeyClass}">
                        <li v-if="chartData.counts !== undefined"
                            v-for="(item, index) in chartData.counts" :key="index">
                            <div class="icon" v-if="renderIcon">
                                <b-icon icon="circle"
                                        :style="'color: ' + chartData.chart.datasets[0]['backgroundColor'][index]"></b-icon>
                            </div>
                            <router-link v-if="route"
                                         :to="{name: route, query: getQueryString(filter, item.id ? item.id : item.name)}"
                                         :title="'View All ' + item.name">
                                <span class="text">{{ item.name }} <span class="count">({{ item.count }})</span></span>
                            </router-link>
                            <span v-else class="text">{{ item.name }} <span class="count">({{ item.count }})</span></span>
                        </li>
                        <li v-if="chartData.counts === undefined"
                            v-for="(item, index) in chartData.chart.labels" :key="index">
                            <div class="icon" v-if="renderIcon">
                                <b-icon icon="circle"
                                        :style="'color: ' + chartData.chart.datasets[0]['backgroundColor'][index]"></b-icon>
                            </div>
                            {{ item }} <span class="count">({{ chartData.chart.datasets[0]['data'][index] }})</span>
                        </li>
                    </ul>
                </div>
                <div class="column is-4 is-hidden-mobil has-text-centered">
                    <div class="chart-container">
                        <doughnut-chart :data="chartData.chart" :options="chartOptions"></doughnut-chart>
                    </div>
                </div>
            </div>
        </article>
    </div>
</template>

<style>
    .chart-container {
        margin-top: -10px;
        height: 90px;
        width: 90px;
        float: right;
    }
</style>

<script>
import { mapState } from 'vuex'
import DoughnutChart from '../Charts/Doughnut'

export default {
  name: 'DoughnutMetric',
  components: {
    DoughnutChart
  },
  props: {
    metric: {
      type: String
    },
    title: {
      type: String,
      default: 'Statistics'
    },
    metricSize: {
      default: 'is-4',
      type: String
    },
    route: {
      type: String
    },
    filter: {
      default: 'unknown',
      type: String
    },
    isParent: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      renderIcon: true,
      chartOptions: {
        legend: {
          display: false
        },
        cutoutPercentage: 70
      }
    }
  },
  watch: {
    modelUpdatedAt: function () {
      if (this.dataChanged === 'data') {
        this.getMetric()
      }
    }
  },
  computed: {
    ...mapState({
      metrics: state => state.metrics.all,
      modelUpdatedAt: state => state.modelUpdatedAt,
      dataChanged: state => state.dataChanged
    }),
    theTitle () {
      if (this.chartData.title !== undefined) return this.chartData.title
      return this.title
    },
    noDataMessage () {
      if (this.chartData.empty !== undefined) return this.chartData.empty
      return 'Not enough data to render chart.'
    },
    chartData () {
      return this.metrics[this.metric]
    },
    chartDataTotal () {
      if (this.loading) return 0
      return this.chartData.total
    },
    loading () {
      if (typeof this.chartData !== 'object') return true
      return Object.keys(this.chartData).length === 0
    },
    chartKeyClass () {
      if (this.chartData.counts !== undefined) {
        if (Object.keys(this.chartData.counts).length > 5) {
          return false
        }
      }

      if (this.chartData.chart !== undefined) {
        if (this.chartData.chart.labels.length > 5) {
          return false
        }
      }

      return true
    },
    hasChartData () {
      if (this.loading) return false
      if (this.chartData.counts === undefined) return false
      if (this.chartData.counts.length === 0) return false

      return true
    }
  },
  methods: {
    forceRerender () {
      this.renderIcon = false

      this.$nextTick(() => {
        this.renderIcon = true
      })
    },
    getMetric (force) {
      if (!force) force = false

      this.$store.dispatch('metrics/getMetric', { metric: this.metric, qs: { force: force } }).then(() => {
        this.forceRerender()
      })
    },
    getQueryString (filter, id) {
      let query = {}
      query['filter__' + filter] = id
      return query
    }
  },
  created () {
    this.getMetric()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Metrics/DoughnutMetric.vue